import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

const Connect = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="connect_gcc_web p-100">
        <Container>
          <Row>
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="connect_head">
                <h2>
                  <span>Creating Extraordinary Experiences:</span> Developing
                  Incredible Mobile Games for You
                </h2>
                <p>
                  TekRevol has been crafting amazing mobile games for years.
                  From arcade games to strategy games to puzzle games and more,
                  we have developed multiple types of games for our clients. Our
                  foremost priority is to understand what our clients need and
                  craft the right strategy to build the perfect mobile game.
                  From using AR and VR for developing highly immersive
                  surroundings to fascinating the users to play more and more,
                  we do it all. Do you want to know more? Connect with us today
                  to get started.
                </p>
                <button onClick={handleShow} className="border_btn dark_btn">
                  Connect Now To Get Started
                </button>
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto offset-xl-1 offset-lg-1 mt-4 mt-md-0"
            >
              <StaticImage
                src="../../../images/locationgcc/game/creating-dubai-game.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1025}
                height={863}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default Connect;
